module.exports = __webpack_public_path__ + "img/BackgroundRemoval02.48442e71.png";